<template>
  <v-container>
    <v-card v-if="filteredCommunications.length">
      <v-card-title class="d-flex" style="align-items: center">
        <div class="admin-buttons d-flex" style="align-items: center">
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-icon
            color="primary"
            @click="openEditDialog(null)"
            style="cursor: pointer"
          >
            add
          </v-icon>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-icon color="primary" @click="exportToCSV" style="cursor: pointer">
            sim_card_download
          </v-icon>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-icon
            color="primary"
            @click="
              searchVisible = !searchVisible;
              search = '';
            "
            style="cursor: pointer"
          >
            search
          </v-icon>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-text-field
            v-if="searchVisible"
            v-model="search"
            label="Search Athlete"
            single-line
            hide-details
            filled
            rounded
            dense
            style="max-width: 130px; margin-left: 8px"
            class="white-search"
          />
        </div>
      </v-card-title>
      <!-- <p> {{ this.leadId }}</p> -->
      <v-data-table
        :headers="headers"
        :items="filteredCommunications"
        :search="search"
        :loading="loading"
        item-value="seqNo"
        class="elevation-1"
        :items-per-page="itemsPerPage"
        :sort-by="'updateDate'"
        :sort-desc="true"
        mobile-breakpoint="960"
      >
        <template #item.details="{ item }">
          <div v-if="item.details.length <= 100">
            {{ item.details }}
          </div>
          <v-tooltip v-else bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                small
                text
                v-bind="attrs"
                v-on="on"
                @click="showDetails(item.details)"
              >
                View
              </v-btn>
            </template>
            <span>{{ truncateText(item.details, 100) }}</span>
          </v-tooltip>
        </template>

        <template #item.actions="{ item }">
          <!-- v-menu that is triggered by the three dots button -->
          <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small>more_vert</v-icon>
              </v-btn>
            </template>
            <!-- Menu content (will only be visible when the menu is active) -->
            <v-list>
              <!-- Edit Action -->
              <v-list-item @click="openEditDialog(item)">
                <v-list-item-icon>
                  <v-icon>edit</v-icon>
                  <!-- Edit icon -->
                </v-list-item-icon>
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <!-- <v-btn x-small @click="sendEmail(item.node)">
                    {{ item.node.email }}
                  </v-btn> -->

              <!-- Delete Action -->
              <v-list-item @click="deleteItem(item)">
                <v-list-item-icon>
                  <v-icon>delete</v-icon>
                  <!-- Delete icon -->
                </v-list-item-icon>
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template #item.subject="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(item.subject, 20) }}
              </div>
            </template>
            <span>{{ item.subject }}</span>
          </v-tooltip>
        </template>

        <template #item.communicationResource="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(item.communicationResource, 15) }}
              </div>
            </template>
            <span>{{ item.communicationResource }}</span>
          </v-tooltip>
        </template>

        <template #item.communicationDate="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(item.communicationDate, 10) }}
              </div>
            </template>
            <span>{{ item.communicationDate }}</span>
          </v-tooltip>
        </template>

        <template #item.followUpDate="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(item.followUpDate, 10) }}
              </div>
            </template>
            <span>{{ item.followUpDate }}</span>
          </v-tooltip>
        </template>

        <template #item.updateDate="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(item.updateDate, 10) }}
              </div>
            </template>
            <span>{{ item.updateDate }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-show="false"
                  v-model="editedItem.leadId"
                  label="Lead ID"
                  :disabled="!!leadId"
                />
              </v-col>

              <v-col cols="12">
                <catValueDropDown
                  :outlined="true"
                  :catName="'COMMUNICAT_TYPE'"
                  v-model.trim="editedItem.communicationType"
                  label="Communication type"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.communicationResource"
                  label="Resource"
                  hint="E.g., Phone number, Email, Messenger"
                  persistent-hint
                />
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="editedItem.subject" label="Subject" />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.details"
                  label="Details"
                  auto-grow
                  hint="Provide a summary of the communication"
                  persistent-hint
                />
              </v-col>

              <v-col cols="12">
                <v-menu
                  v-model="commDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.communicationDate"
                      label="Communication Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="editedItem.communicationDate"
                    @input="commDateMenu = false"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12">
                <v-menu
                  v-model="followDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.followUpDate"
                      label="Follow-up Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="editedItem.followUpDate"
                    @input="followDateMenu = false"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12">
                <catValueDropDown
                  :outlined="true"
                  :catName="'FOLLOWUP_STATUS'"
                  v-model.trim="editedItem.followUpStatus"
                  label="Follow-up Status"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Details HTML Dialog -->
    <v-dialog v-model="detailsDialog" max-width="800px">
      <v-card>
        <v-card-title>Communication Details</v-card-title>
        <v-card-text>
          <div
            v-html="selectedHtmlDetails"
            style="max-height: 70vh; overflow-y: auto"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="detailsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DOMPurify from "dompurify";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";

export default {
  props: {
    leadId: Number,
    phone: String,
    email: String,
  },
  components: {
    catValueDropDown,
  },
  data() {
    return {
      loading: true,
      editDialog: false,
      detailsDialog: false,
      commDateMenu: false,
      followDateMenu: false,
      selectedHtmlDetails: "",
      editedIndex: -1,
      itemsPerPage: 50,
      search: "",
      communications: [],
      editedItem: {},
      searchVisible: false,
      defaultItem: {
        seqNo: 0,
        leadId: this.leadId ? this.leadId : "",
        communicationType: "Phone Call",
        communicationResource: this.phone,
        subject: "",
        details: "",
        communicationDate: new Date().toISOString().split("T")[0],
        followUpDate: new Date(new Date().setDate(new Date().getDate() + 3))
          .toISOString()
          .split("T")[0],
        followUpStatus: "Pending",
        updateSource: "",
      },
      headers: [
        // { text: "Lead ID", value: "leadId" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "Type", value: "communicationType" },
        { text: "Subject", value: "subject" },
        { text: "Details", value: "details", sortable: false },
        { text: "Status", value: "followUpStatus" },
        { text: "Resource", value: "communicationResource" },
        { text: "Follow-up", value: "followUpDate" },
        { text: "Communication Date", value: "communicationDate" },
        { text: "Updated", value: "updateDate" },
        { text: "Source", value: "updateSource" },
      ],
    };
  },
  computed: {
    ...mapGetters(["allPersonCommunications", "user"]),
    filteredCommunications() {
      console.log("leadid",this.leadId)
      return this.leadId
        ? this.communications.filter((c) => Number(c.leadId) == Number(this.leadId))
        : this.communications;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "New Communication"
        : "Edit Communication";
    },
    communicationResource() {
      return this.communicationType == "Phone Call" ? this.phone : this.email;
    },
  },
  watch: {
    "editedItem.communicationType"(newValue) {
      console.log("Communication type changed to:", newValue);
      switch (newValue) {
        case "Email":
          this.editedItem.communicationResource = this.email;
          break;
        case "Phone Call":
          this.editedItem.communicationResource = this.phone;
          break;
        case "WhatsApp":
          this.editedItem.communicationResource = this.phone;
          break;
        case "WhatsApp":
          this.editedItem.communicationResource = this.phone;
          break;
        case "SMS":
          this.editedItem.communicationResource = this.phone;
          break;
        default:
          this.editedItem.communicationResource = "";
      }
    },
    allPersonCommunications: {
      handler(newVal) {
        this.communications = newVal.edges.map((e) => e.node) || [];
        console.log("this.commun",this.communications)
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    await this.$store.dispatch("allPersonCommunications");
    this.loading = false;
  },
  methods: {
    openEditDialog(item) {
      this.editedIndex = this.communications.findIndex(
        (c) => c.seqNo === (item ? item.seqNo : null)
      );
      this.editedItem = item ? { ...item } : { ...this.defaultItem };
      if (this.seqNo) this.editedItem.seqNo = this.seqNo;
      this.editDialog = true;
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("personCommunicationsDelete", {
          seqNo: item.seqNo,
        });
      }
    },
    save() {
      this.editedItem.updateSource = this.user.userName;
      const payload =
        this.editedItem.seqNo === 0
          ? { ...this.editedItem, seqNo: undefined }
          : this.editedItem;

      this.$store.dispatch("personCommunicationsMerge", payload);
      this.editDialog = false;
    },
    showDetails(html) {
      this.selectedHtmlDetails = DOMPurify.sanitize(html);
      this.detailsDialog = true;
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    formatDate(dateStr) {
      return dateStr ? dateStr.split("T")[0] : "";
    },
    exportToCSV() {
      const rows = [this.headers.map((h) => h.text)];
      this.filteredCommunications.forEach((item) => {
        const row = this.headers.map((h) => item[h.value]);
        rows.push(row);
      });
      const csvContent = rows.map((e) => e.join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "communications.csv";
      link.click();
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },
  },
};
</script>
